import { c as _c } from "react/compiler-runtime";
import Cookies from 'js-cookie';
import useSearchParamByName from './useSearchParamByName';
export const COOKIE_KEY_PROMO_SOURCE = `promoSource`;
export const COOKIE_KEY_PREFERRED_PROMO_SOURCE = `preferredPromoSource`;
export const getPromoSourceFromCookies = () => Cookies.get(COOKIE_KEY_PROMO_SOURCE);
export const getPreferredPromoSourceFromCookies = () => Cookies.get(COOKIE_KEY_PREFERRED_PROMO_SOURCE);
const usePromoSource = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      name: "promo"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const promoSourceFromSearchParams = useSearchParamByName(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getPromoSourceFromCookies();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const promoSourceFromCookies = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getPreferredPromoSourceFromCookies();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const preferredPromoSourceFromCookies = t2;
  if (promoSourceFromSearchParams) {
    Cookies.set(COOKIE_KEY_PREFERRED_PROMO_SOURCE, promoSourceFromSearchParams, {
      expires: 30
    });
    if (!promoSourceFromCookies) {
      Cookies.set(COOKIE_KEY_PROMO_SOURCE, promoSourceFromSearchParams, {
        expires: 30
      });
    }
    return promoSourceFromSearchParams;
  }
  return preferredPromoSourceFromCookies || promoSourceFromCookies || null;
};
export default usePromoSource;